import React, { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import MainLayout from "../../layouts/MainLayout";
import ProtectedRoute from "../../components/auth/ProtectedRoute";
import ErrorBoundary from "../../features/shared/pages/ErrorBoundary";
import UnderDevelopment from "../../features/shared/pages/UnderDevelopment";
import PageLoader from "../../components/common/PageLoader";
import { APP_ROUTES } from "../routePaths";

// Lazy-loaded page components for code splitting
const Supplier = lazy(() => import("../../features/Supplier/pages/Supplier"));
const AgentMasterCompany = lazy(() => import("../../features/agent-master/pages/AgentmasterCompanyadd"));
const AgentMaster = lazy(() => import("../../features/agent-master/pages/AgentMaster"));
const AgentMasterView = lazy(() => import("../../features/agent-master/pages/AgentMasterView"));
const AddressMaster = lazy(() => import("../../features/Address/AddressMaster"));
const Employee = lazy(() => import("../../features/employee-master/pages/Employee"));
const PlanningList = lazy(() => import("../../features/Planning/PlanningList"));
const PlanningView = lazy(() => import("../../features/Planning/PlanningView"));
const VesselPlanningListPage = lazy(() => import("../../features/vessel-planning/pages/VesselPlanningListPage"));
const VesselPlanningViewPage = lazy(() => import("../../features/vessel-planning/pages/VesselPlanningViewPage"));




export const legacyRoutes = [
  // Legacy Routes (for backward compatibility)
  // Old React-only customer paths: send bookmarks to the .NET-shaped ones.
  {
    path: "/customer",
    element: (
      <ProtectedRoute>
        <Navigate replace to={APP_ROUTES.customerMaster} />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/customer-view",
    element: (
      <ProtectedRoute>
        <Navigate replace to={APP_ROUTES.customerMasterView} />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    caseSensitive: true,
    path: APP_ROUTES.saleOrderLegacyPlural,
    element: (
      <ProtectedRoute>
        <Navigate replace to={APP_ROUTES.saleOrder} />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/supplier",
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [{ index: true, element: <Suspense fallback={<PageLoader />}><Supplier /></Suspense> }],
  },
  {
    path: "/employee",
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [{ index: true, element: <Suspense fallback={<PageLoader />}><Employee /></Suspense> }],
  },
  {
    path: "/agent-company",
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [{ index: true, element: <Suspense fallback={<PageLoader />}><AgentMasterCompany /></Suspense> }],
  },
  {
    path: "/agent-master",
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [{ index: true, element: <Suspense fallback={<PageLoader />}><AgentMaster /></Suspense> }],
  },
  {
    path: "/agent-master-view",
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [{ index: true, element: <Suspense fallback={<PageLoader />}><AgentMasterView /></Suspense> }],
  },
  {
    path: "/address-master",
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [{ index: true, element: <Suspense fallback={<PageLoader />}><AddressMaster /></Suspense> }],
  },
  {
    caseSensitive: true,
    path: APP_ROUTES.planning,
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [{ index: true, element: <Suspense fallback={<PageLoader />}><PlanningList /></Suspense> }],
  },
  {
    caseSensitive: true,
    path: APP_ROUTES.planningView,
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [{ index: true, element: <Suspense fallback={<PageLoader />}><PlanningView /></Suspense> }],
  },
  {
    caseSensitive: true,
    path: APP_ROUTES.planningEdit(),
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [{ index: true, element: <Suspense fallback={<PageLoader />}><PlanningList /></Suspense> }],
  },
  {
    caseSensitive: true,
    path: APP_ROUTES.vesselPlanningList,
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [{ index: true, element: <Suspense fallback={<PageLoader />}><VesselPlanningListPage /></Suspense> }],
  },
  {
    caseSensitive: true,
    path: APP_ROUTES.vesselPlanningView(),
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [{ index: true, element: <Suspense fallback={<PageLoader />}><VesselPlanningViewPage /></Suspense> }],
  },
  {
    caseSensitive: true,
    path: APP_ROUTES.vesselPlanning,
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [{ index: true, element: <Suspense fallback={<PageLoader />}><VesselPlanningViewPage /></Suspense> }],
  },
  {
    path: "/under-development",
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorBoundary />,
    children: [{ index: true, element: <UnderDevelopment /> }],
  },
];

